import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  mainContainer: {
    marginTop:  '10px',
    flexWrap: 'wrap',
    padding: 16
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '5px',
    alignItems: 'center',
  },
  userContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    borderBottom: '1px solid #80808059',
    paddingRight: 40
  },
  titles: {
    fontFamily: 'Nunito, sans-serif',
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#FAA500',
  },
  description: {
    fontFamily: 'Nunito, sans-serif',
    fontSize: '14px',
    fontWeight: 'bold',
  }
}))